import { LelyTableActionsConfig } from '@hn-work/frontend-vue-shared';
import Vue from 'vue';
import Component from 'vue-class-component';
import confirmDeleteDialog from '@/core/confirm-delete';

@Component({})
export default class OverviewTable<T> extends Vue {
    actions: LelyTableActionsConfig<T> = [
        {
            name: 'delete',
            label: 'Delete',
            icon: 'lely-icon-trash',
            variant: 'warning',
        },
        {
            name: 'edit',
            label: 'Edit',
            icon: 'lely-icon-edit',
        },
    ];

    async confirmDelete(item: T, name: string): Promise<void> {
        const confirmed = await confirmDeleteDialog(this, 'Are you sure you want to delete {name}?', { name });

        if (!confirmed) {
            return;
        }

        // @ts-ignore
        await this.deleteAction(item.id);
    }
}
